export AccountList = '''
	name
	id
	slug
	numberOfOpportunities
'''
